import { render, staticRenderFns } from "./StatusDashboardIssueList.vue?vue&type=template&id=2463c9b4"
import script from "./StatusDashboardIssueList.vue?vue&type=script&lang=js"
export * from "./StatusDashboardIssueList.vue?vue&type=script&lang=js"
import style0 from "./StatusDashboardIssueList.vue?vue&type=style&index=0&id=2463c9b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports